import {ErrorMessage} from "@atlaskit/form";
import type {ComponentProps} from "react";

export function AnankeErrorMessage(props: ComponentProps<typeof ErrorMessage>) {
    return <ErrorMessage {...props} />;
}
